import React from 'react';
import Fade from 'react-reveal/Fade';
import { MDBRow, Jumbotron } from
    "mdbreact";


const Testimonials = () => {

    return(

<Fade bottom cascade>
    <MDBRow>

        
        <Jumbotron style={{ marginTop: "25px", color: 'black', position: 'relative', width: '100%' }}>
                    

                        <img src="https://mdbootstrap.com/img/Photos/Avatars/img(31).jpg" className="img-fluid z-depth-1 rounded-circle"
                            alt="Responsive image" style={{width: "150px"}}/>

            
            <blockquote className="blockquote text-center">
                <p className="mb-0">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.</p>
                <footer className="blockquote-footer mb-3">Someone famous in <cite title="Source Title">Source Title</cite></footer>
            </blockquote>
        </Jumbotron>
</MDBRow>
</Fade>

    );
  
};

export { Testimonials }